import { IconEmailMedium, IconMail } from '@/assets/icons';
import { Size } from '@/hooks/useScreenSize';

const aboutyouFormContainerClassMap: Record<Size, string> = {
  sm: 'mx-auto space-y-4 px-2 text-white ',
  md: 'mx-auto space-y-4 px-4 text-white',
  lg: 'mx-auto space-y-4 rounded-xl px-4 text-white ',
  xl: 'mx-auto space-y-4 rounded-xl px-4 text-white ',
  xxl: 'mx-auto space-y-4 rounded-xl px-4 text-white ',
};

const headerFormContainerClassMap: Record<Size, string> = {
  sm: 'text-[14px] h-[42px] w-[263px] font-bold flex items-center text-color-content-text-primary leading-lineHeight-lg spacing-xs',
  md: 'text-[16px] h-[54.6px] w-[630px] flex items-center flex-row font-bold text-color-content-text-primary leading-lineHeight-xl ',
  lg: 'text-[20px] h-[54.6px] w-[614px] flex items-center flex-row font-bold text-color-content-text-primary leading-lineHeight-2xl',
  xl: 'text-[20px] 2xl:text-[24px] h-[54.6px] w-[614px] flex items-center flex-row font-bold text-color-content-text-primary leading-lineHeight-2xl',
  xxl: 'text-[24px] h-[59.32px] w-[954px] flex items-center flex-row font-bold text-color-content-text-primary leading-lineHeight-4xl',
};

const mobileFormContainerClassMap: Record<Size, string> = {
  sm: 'py-spacing-3xs pl-[16px] pr-spacing-lg ',
  md: 'py-spacing-2xs pr-spacing-3xl pl-spacing-md',
  lg: 'py-spacing-sm pr-spacing-5xl pl-spacing-2xl',
  xl: 'py-spacing-sm pr-spacing-5xl pl-spacing-2xl',
  xxl: 'py-spacing-sm pr-spacing-5xl pl-spacing-2xl',
};

const inputFormContainerClassMap: Record<Size, string> = {
  sm: 'space-y-4 flex flex-col justify-center items-center m-auto',
  md: 'space-y-4 flex flex-col justify-center items-center m-auto',
  lg: 'space-y-4 flex flex-col justify-center items-center m-auto',
  xl: 'space-y-4 flex flex-col justify-center items-center m-auto',
  xxl: 'space-y-4  flex flex-col justify-center items-center m-auto',
};

const firstNameContainerClassMap: Record<Size, string> = {
  sm: 'h-[44px] w-[328px] rounded-md bg-color-background-input-default p-3 text-fontSize-inputField-sm font-normal text-color-content-text-primary leading-lineHeight-xl focus:border-input-border-focus',
  md: 'h-[58px] w-[426px] rounded-md bg-color-background-input-default p-3 text-fontSize-inputField-md font-normal text-color-content-text-primary leading-lineHeight-2xl',
  lg: 'h-[75px] w-[554px] rounded-md bg-color-background-input-default p-3 text-fontSize-inputField-lg font-normal text-color-content-text-primary leading-lineHeight-4xl',
  xl: 'h-[75px] w-[554px]  rounded-md bg-color-background-input-default p-3 text-fontSize-inputField-lg font-normal text-color-content-text-primary leading-lineHeight-4xl',
  xxl: 'h-[96px] w-[720px] rounded-md bg-color-background-input-default p-3 text-fontSize-inputField-xl font-normal text-color-content-text-primary leading-lineHeight-7xl',
};

const lastNameContainerClassMap: Record<Size, string> = {
  sm: 'h-[44px] w-[328px] rounded-md bg-color-background-input-default p-3 text-fontSize-inputField-sm font-normal text-color-content-text-primary leading-lineHeight-xl',
  md: 'h-[58px] w-[426px] rounded-md bg-color-background-input-default p-3 text-fontSize-inputField-md font-normal text-color-content-text-primary leading-lineHeight-2xl',
  lg: 'h-[75px] w-[554px] rounded-md bg-color-background-input-default p-3 text-fontSize-inputField-lg font-normal text-color-content-text-primary leading-lineHeight-4xl',
  xl: 'h-[75px] w-[554px]  rounded-md bg-color-background-input-default p-3 text-fontSize-inputField-lg font-normal text-color-content-text-primary leading-lineHeight-4xl',
  xxl: 'h-[96px] w-[720px] rounded-md bg-color-background-input-default p-3 text-fontSize-inputField-xl font-normal text-color-content-text-primary leading-lineHeight-7xl',
};

const PhoneContainerClassMap: Record<Size, string> = {
  sm: 'flex h-[44px] w-[328px] gap-2',
  md: 'flex h-[58px] w-[426px] gap-2',
  lg: 'flex h-[75px] w-[554px] gap-2',
  xl: 'flex  h-[75px] w-[554px] gap-2',
  xxl: 'flex h-[96px] w-[720px] gap-2',
};

const areaCodeContainerClassMap: Record<Size, string> = {
  sm: 'h-[44px] w-[101px] rounded-md bg-color-background-input-default  font-normal border-none text-white relative leading-lineHeight-xl text-color-content-text-primary text-fontSize-inputField-sm ',
  md: 'h-[58px] w-[131px] rounded-md bg-color-background-input-default  font-normal border-none text-white relative text-color-content-text-primary leading-lineHeight-2xl text-fontSize-inputField-md ',
  lg: 'h-[75px] w-[170px] rounded-md bg-color-background-input-default  font-normal border-none text-white relative text-color-content-text-primary leading-lineHeight-4xl text-fontSize-inputField-lg ',
  xl: 'h-[75px] w-[170px]  rounded-md bg-color-background-input-default font-normal border-none text-white relative text-color-content-text-primary leading-lineHeight-4xl text-fontSize-inputField-lg ',
  xxl: 'h-[96px] w-[221px] rounded-md bg-color-background-input-default  font-normal border-none text-white relative text-color-content-text-primary leading-lineHeight-7xl text-fontSize-inputField-xl ',
};

const phoneNumerContainerClassMap: Record<Size, string> = {
  sm: 'h-[44px] w-[328px] rounded-md bg-color-background-input-default p-3 font-normal text-color-content-text-primary leading-lineHeight-xl text-fontSize-inputField-sm ',
  md: 'h-[58px] w-[426px] rounded-md bg-color-background-input-default p-3 font-normal text-color-content-text-primary leading-lineHeight-2xl text-fontSize-inputField-md ',
  lg: 'h-[75px] w-[554px] rounded-md bg-color-background-input-default p-3 font-normal text-color-content-text-primary leading-lineHeight-4xl text-fontSize-inputField-lg ',
  xl: 'h-[75px] w-[554px] rounded-md bg-color-background-input-default p-3 font-normal text-color-content-text-primary leading-lineHeight-4xl text-fontSize-inputField-lg ',
  xxl: 'h-[96px] w-[720px] rounded-md bg-color-background-input-default p-3 font-normal text-color-content-text-primary leading-lineHeight-7xl text-fontSize-inputField-xl ',
};

const dateOfBirthContainerClassMap: Record<Size, string> = {
  sm: 'h-[44px] w-[328px] rounded-md bg-color-background-input-default px-3 py-[12px] text-fontSize-inputField-sm font-[450] leading-lineHeight-xl text-color-content-text-primary',
  md: 'h-[58px] w-[426px] rounded-md bg-color-background-input-default px-[18px] py-[15px] text-fontSize-inputField-md font-[450] leading-lineHeight-2xl text-color-content-text-primary',
  lg: 'h-[75px] w-[554px] rounded-md bg-color-background-input-default px-7 py-[18px] text-[24px] font-[450] leading-[36px] text-color-content-text-primary',
  xl: 'h-[75px] w-[554px] rounded-md bg-color-background-input-default px-7 py-[18px] text-[24px] font-[450] leading-[36px] text-color-content-text-primary',
  xxl: 'h-[96px] w-[720px] rounded-md bg-color-background-input-default px-8 py-[24px] text-[28px] font-[450] leading-[42px] text-color-content-text-primary',
};

const emailContainerClassMap: Record<Size, string> = {
  sm: 'h-[44px] w-[328px] rounded-md bg-color-background-input-default p-3 !pr-[52px] text-color-content-text-primary leading-lineHeight-xl text-fontSize-inputField-sm font-normal ',
  md: 'h-[58px] w-[426px] rounded-md bg-color-background-input-default p-3 !pr-[60px] font-normal text-color-content-text-primary leading-lineHeight-2xl text-fontSize-inputField-md ',
  lg: 'h-[75px] w-[554px] rounded-md bg-color-background-input-default p-3 !pr-[72px] font-normal text-color-content-text-primary leading-lineHeight-4xl text-fontSize-inputField-lg ',
  xl: 'h-[75px] w-[554px]  rounded-md bg-color-background-input-default p-3 !pr-[72px] font-normal text-color-content-text-primary leading-lineHeight-4xl text-fontSize-inputField-lg ',
  xxl: 'h-[96px] w-[720px] rounded-md bg-color-background-input-default p-3 !pr-[92px] font-normal text-color-content-text-primary leading-lineHeight-7xl text-fontSize-inputField-xl ',
};

const CheckBoxContainerClassMap: Record<Size, string> = {
  sm: 'flex items-start w-[328px]',
  md: 'flex items-center w-[426px]',
  lg: 'flex items-start w-[554px]',
  xl: 'flex items-start w-[554px]',
  xxl: 'flex items-start w-[720px]',
};

const CheckBoxFieldClassMap: Record<Size, string> = {
  sm: 'border-2 font-normal border-color-border-checkbox-secondary checked:bg-color-background-icons-checkbox-active-Square checked:text-color-content-text-primary leading-lineHeight-lg text-fontSize-checkBox-sm text-color-content-text-primary ',
  md: 'border-2 font-normal border-color-border-checkbox-secondary checked:bg-color-background-icons-checkbox-active-Square checked:text-color-content-text-primary leading-lineHeight-xl text-fontSize-checkBox-md text-color-content-text-primary',
  lg: 'border-2 font-normal border-color-border-checkbox-secondary checked:bg-color-background-icons-checkbox-active-Square checked:text-color-content-text-primary leading-lineHeight-2xl text-fontSize-checkBox-lg text-color-content-text-primary',
  xl: 'border-2 font-normal border-color-border-checkbox-secondary checked:bg-color-background-icons-checkbox-active-Square checked:text-color-content-text-primary leading-lineHeight-2xl text-fontSize-checkBox-lg text-color-content-text-primary mt-1',
  xxl: 'border-2 font-normal border-color-border-checkbox-secondary checked:bg-color-background-icons-checkbox-active-Square checked:text-color-content-text-primary leading-lineHeight-4xl text-fontSize-checkBox-xl text-color-content-text-primary mt-1',
};

// const errorMsgContainerClassMap: Record<Size, string> = {
//   sm: 'text-[10px] text-red-500',
//   md: 'fontSize-inputField-sm text-red-500',
//   lg: 'fontSize-inputField-sm text-red-500',
//   xl: 'fontSize-inputField-sm text-red-500',
//   xxl: 'text-lg text-red-500',
// };

const IconClassMap: Record<Size, string> = {
  sm: 'top-2',
  md: 'top-3',
  lg: 'top-3',
  xl: 'top-3',
  xxl: 'top-3',
};

const IconRightClassMap: Record<Size, string> = {
  sm: 'right-[14px]',
  md: 'right-[14px]',
  lg: 'right-[24px]',
  xl: 'right-[24px]',
  xxl: 'right-[32px]',
};

const IconCheckboxClassMap: Record<Size, string> = {
  sm: 'border-color-border-checkbox-secondary mr-1',
  md: 'border-color-border-checkbox-secondary mr-1',
  lg: 'border-color-border-checkbox-secondary mr-1',
  xl: 'border-color-border-checkbox-secondary mt-1 mr-1',
  xxl: 'border-color-border-checkbox-secondary mt-1 mr-1',
};

const IconContainerClassMap: Record<Size, string> = {
  sm: 'h-5 w-5 text-gray-400 items-center flex flex-col justify-center',
  md: 'h-5 w-5 text-gray-400 items-center mr-4 flex flex-col justify-center',
  lg: 'h-5 w-5 text-gray-400 mr-4 items-center flex flex-col justify-center',
  xl: 'h-5 w-5 text-gray-400 mr-4 items-center flex flex-col justify-center',
  xxl: 'h-5 w-5 text-gray-400 mr-4 items-center flex flex-col justify-center',
};

const IconPhoneContainerClassMap: Record<Size, string> = {
  sm: 'h-5 w-5 text-gray-400 items-center mr-4 ',
  md: 'h-5 w-5 text-gray-400 items-center mr-4',
  lg: 'h-5 w-5 text-gray-400 mr-4 items-center flex flex-col justify-center',
  xl: 'h-5 w-5 text-gray-400 mr-4 items-center flex flex-col justify-center',
  xxl: 'h-5 w-5 text-gray-400 mr-4 items-center flex flex-col justify-center',
};
const IconEmailSizeContainerClassMap: Record<Size, JSX.Element> = {
  sm: <IconMail className="mr-4 h-5 w-5 items-center text-gray-400" />,
  md: <IconEmailMedium className="mr-4 h-5 w-5 items-center justify-center text-gray-400" />,
  lg: <IconEmailMedium className="mr-4 h-5 w-5 items-center justify-center text-gray-400" />,
  xl: <IconEmailMedium className="mr-4 h-5 w-5 items-center justify-center text-gray-400" />,
  xxl: <IconEmailMedium className="mr-4 h-5 w-5 items-center justify-center text-gray-400" />,
};

const errorMsgContainerClassMap: Record<Size, string> = {
  sm: ' left-0 text-fontSize-paragraph-body-3xs text-red-500 pt-[4px]',
  md: ' left-0 text-fontSize-paragraph-body-2xs text-red-500 pt-[8px]',
  lg: ' left-0 text-fontSize-paragraph-body-xs text-red-500 pt-[8px]',
  xl: ' left-0 text-fontSize-paragraph-body-xs text-red-500 pt-[8px]',
  xxl: ' left-0 text-fontSize-paragraph-body-sm text-red-500 pt-[8px]',
};
const iconSizeClassMap: Record<Size, string> = {
  sm: 'h-[27px] w-[27px]',
  md: 'w-[35px] h-[35px]',
  lg: 'w-[45px] h-[45px] ',
  xl: 'w-[45px] h-[45px] ',
  xxl: 'w-[59px] h-[59px]',
};

// const iconChooseSizeClassMap: Record<Size, string> = {
//   sm: 'h-[13.19px] w-[13.19px]',
//   md: 'w-[17.15px] h-[17.15px]',
//   lg: 'w-[22.3px] h-[22.3px] ',
//   xl: 'w-[22.3px] h-[22.3px] ',
//   xxl: 'w-[28.98px] h-[28.98px]',
// };

const inputFormSpaceContainerClassMap: Record<Size, string> = {
  sm: 'py-spacing-3xs pl-[16px] pr-spacing-lg',
  md: 'py-spacing-2xs pl-spacing-md pr-spacing-3xl',
  lg: 'py-spacing-sm pl-spacing-2xl pr-spacing-5xl',
  xl: 'py-spacing-sm pl-spacing-2xl pr-spacing-5xl',
  xxl: 'py-spacing-lg pl-spacing-4xl pr-spacing-7xl',
};

const informationDetailsContianerClassMap: Record<Size, string> = {
  sm: 'flex items-start w-[328px] m-auto bg-color-background-button-tertiary-dakbg-alpha-8 p-spacing-spacing-16 rounded-border-radius-sm gap-spacing-4xs',
  md: 'flex items-start w-[426px] m-auto bg-color-background-button-tertiary-dakbg-alpha-8 p-spacing-spacing-16 rounded-border-radius-md gap-spacing-4xs',
  lg: 'flex items-start w-[554px] m-auto bg-color-background-button-tertiary-dakbg-alpha-8 p-spacing-lg rounded-border-radius-lg gap-spacing-4xs',
  xl: 'flex items-start w-[554px] m-auto bg-color-background-button-tertiary-dakbg-alpha-8 p-spacing-lg rounded-border-radius-lg gap-spacing-4xs',
  xxl: 'flex items-start w-[720px] m-auto bg-color-background-button-tertiary-dakbg-alpha-8 p-spacing-lg rounded-border-radius-lg gap-spacing-xs',
};
const customerInfoDetailsClassName =
  'bg-Gradients-background-info-card border-l-2 border-color-border-checkbox-secondary';

const infoTextClassMap: Record<Size, string> = {
  sm: 'font-font-family-primary text-color-content-text-primary text-font-size-paragraph-SubTitle-xs leading-line-height-lg',
  md: 'font-font-family-primary text-color-content-text-primary text-font-size-paragraph-SubTitle-sm leading-line-height-xl',
  lg: 'font-font-family-primary text-color-content-text-primary text-font-size-paragraph-SubTitle-md leading-line-height-2xl',
  xl: 'font-font-family-primary text-color-content-text-primary text-font-size-paragraph-SubTitle-md leading-line-height-2xl',
  xxl: 'font-font-family-primary text-color-content-text-primary text-font-size-paragraph-SubTitle-lg leading-line-height-3xl',
};

const skeletonLoaderClassMap: Record<Size, string> = {
  sm: 'flex items-start w-[328px] h-[100px] m-auto bg-color-midnight-lightMidnight-alpha-50 p-spacing-spacing-16 rounded-border-radius-sm gap-spacing-4xs animate-pulse',
  md: 'flex items-start w-[426px] h-[125px] m-auto bg-color-midnight-lightMidnight-alpha-50 p-spacing-spacing-16 rounded-border-radius-md gap-spacing-4xs animate-pulse',
  lg: 'flex items-start w-[554px] h-[150px] m-auto bg-color-midnight-lightMidnight-alpha-50 p-spacing-lg rounded-border-radius-lg gap-spacing-4xs animate-pulse',
  xl: 'flex items-start w-[554px] h-[150px] m-auto bg-color-midnight-lightMidnight-alpha-50 p-spacing-lg rounded-border-radius-lg gap-spacing-4xs animate-pulse',
  xxl: 'flex items-start w-[720px] h-[175px] m-auto bg-color-midnight-lightMidnight-alpha-50 p-spacing-lg rounded-border-radius-lg gap-spacing-xs animate-pulse',
};

export {
  aboutyouFormContainerClassMap,
  headerFormContainerClassMap,
  inputFormContainerClassMap,
  firstNameContainerClassMap,
  lastNameContainerClassMap,
  areaCodeContainerClassMap,
  phoneNumerContainerClassMap,
  emailContainerClassMap,
  dateOfBirthContainerClassMap,
  CheckBoxContainerClassMap,
  CheckBoxFieldClassMap,
  errorMsgContainerClassMap,
  IconContainerClassMap,
  IconPhoneContainerClassMap,
  PhoneContainerClassMap,
  IconEmailSizeContainerClassMap,
  IconClassMap,
  IconCheckboxClassMap,
  iconSizeClassMap,
  mobileFormContainerClassMap,
  inputFormSpaceContainerClassMap,
  IconRightClassMap,
  informationDetailsContianerClassMap,
  customerInfoDetailsClassName,
  infoTextClassMap,
  skeletonLoaderClassMap,
};
